import { EWKTToGeoJSONObject, GeoJSONToEWKT, parseEWKT } from '../ewkt';
/**
 * Create rectangular area from point encoded in EWKT
 *
 * A -dx- B
 * |      | dy
 * D ---- C
 *
 * @param geom EWKT
 * @param distanceInMeters Toto je vzdalenost v metrech pouze priblizna
 * @returns EWKT
 */
export const EWKTRectangularBuffer = (geom, distanceInMeters) => {
    const { epsg: geomProjection } = parseEWKT(geom);
    const point = EWKTToGeoJSONObject(geom);
    let dx = distanceInMeters;
    let dy = distanceInMeters;
    switch (geomProjection) {
        // Krovak, metry jsou jasny, ok
        case 'EPSG:5514': {
            break;
        }
        // Web Mercator, priblizne metry, ok
        case 'EPSG:3857': {
            break;
        }
        // WGS 84 - stupne
        case 'EPSG:4326': {
            // 1 degree of latitude corresponds to 111km
            dx /= 111000;
            // 1 degree of longitude corresponds to 73km
            dy /= 73000;
            break;
        }
        default: {
            console.warn(`[EWKTRectangularBuffer] unknown projection ${geomProjection}`);
        }
    }
    const [px, py] = point.geometry.coordinates;
    const A = [px - dx, py - dy];
    const B = [px + dx, py - dy];
    const C = [px + dx, py + dy];
    const D = [px - dx, py + dy];
    const rectangle = {
        type: 'Feature',
        geometry: {
            type: 'Polygon',
            coordinates: [[A, B, C, D, A]],
        },
        properties: {
            __targetCRS: geomProjection,
        },
    };
    const rectangleEwkt = GeoJSONToEWKT(rectangle, geomProjection);
    return rectangleEwkt;
};
//# sourceMappingURL=EWKTBuffer.js.map